export const WIDGET_STYLES = `
.lm-widget {
  box-sizing: border-box;
  --lm-widget-link: #09665f;
  --lm-widget-link-hover: #074942;
  --lm-widget-link-soft: rgba(9, 102, 95, 0.14);
  --lm-widget-focus: rgba(216, 164, 65, 0.45);
  color: var(--lm-widget-text, #171717);
  background: var(--lm-widget-bg, #ffffff);
  border: 1px solid var(--lm-widget-border, #d7d2c8);
  border-radius: 8px;
  font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
  font-size: 16px;
  line-height: 1.45;
  max-width: 100%;
  overflow: hidden;
  padding: 16px;
}
.lm-widget *, .lm-widget *::before, .lm-widget *::after {
  box-sizing: inherit;
}
.lm-widget__header {
  background: var(--lm-widget-header-bg, #f2eadc);
  border-bottom: 1px solid var(--lm-widget-border, #ded4c3);
  display: grid;
  gap: 3px;
  margin: -16px -16px 14px;
  padding: 12px 16px;
}
.lm-widget__title {
  color: var(--lm-widget-heading, #0a3f3a);
  font-size: 1.08em;
  font-weight: 700;
  margin: 0;
}
.lm-widget__subtitle,
.lm-widget__message {
  color: var(--lm-widget-muted, #555047);
  margin: 0;
}
.lm-widget__events {
  display: grid;
  gap: 12px;
  list-style: none;
  margin: 0;
  padding: 0;
}
.lm-event {
  border-top: 1px solid var(--lm-widget-divider, #e7dfd2);
  display: grid;
  gap: 6px;
  padding-top: 14px;
}
.lm-event:first-child {
  border-top: 0;
  padding-top: 0;
}
.lm-event__body {
  display: grid;
  gap: 6px;
  min-width: 0;
}
.lm-event--with-image {
  align-items: start;
  column-gap: 12px;
  grid-template-columns: 5.5em minmax(0, 1fr);
}
.lm-event__image-link,
.lm-event__image {
  aspect-ratio: 1 / 1;
  border-radius: 6px;
  display: block;
  overflow: hidden;
  width: 5.5em;
}
.lm-event__image-link {
  background: var(--lm-widget-link-soft);
  position: relative;
}
.lm-event__image {
  background: var(--lm-widget-divider, #e7dfd2);
  object-fit: cover;
  opacity: 1;
  position: relative;
  transition: opacity 180ms ease;
  z-index: 1;
}
.lm-event__image-link--loading .lm-event__image {
  opacity: 0;
}
.lm-event__image-link--loading::before,
.lm-event__image--loading {
  animation: lm-event-image-loading 1.1s ease-in-out infinite;
  background: linear-gradient(
    100deg,
    var(--lm-widget-divider, #e7dfd2) 0%,
    var(--lm-widget-link-soft) 50%,
    var(--lm-widget-divider, #e7dfd2) 100%
  );
  background-size: 200% 100%;
}
.lm-event__image-link--loading::before {
  border-radius: inherit;
  content: "";
  inset: 0;
  position: absolute;
  z-index: 0;
}
.lm-event__image-link--loaded::before {
  content: none;
}
.lm-event__title {
  color: var(--lm-widget-link);
  font-weight: 700;
  text-decoration: underline;
  text-decoration-color: transparent;
  text-decoration-thickness: 2px;
  text-underline-offset: 3px;
  transition: color 140ms ease, text-decoration-color 140ms ease, background-color 140ms ease;
}
.lm-event__title:hover,
.lm-event__image-link:hover + .lm-event__body .lm-event__title,
.lm-widget__more:hover,
.lm-widget__cta:hover,
.lm-event__venue a:hover,
.lm-event__artists a:hover {
  color: var(--lm-widget-link-hover);
  text-decoration-color: currentColor;
}
.lm-event__meta {
  display: grid;
  gap: 5px;
}
.lm-event__meta-row {
  align-items: baseline;
  display: grid;
  gap: 8px;
  grid-template-columns: minmax(3.75em, max-content) minmax(0, 1fr);
}
.lm-event__meta-label {
  color: var(--lm-widget-label, #6c665d);
  font-size: 0.78em;
  font-weight: 700;
  letter-spacing: 0.02em;
  text-transform: uppercase;
}
.lm-event__date {
  color: var(--lm-widget-meta, #4b4740);
  font-size: 0.94em;
  margin: 0;
}
.lm-event__venue,
.lm-event__artists {
  color: var(--lm-widget-meta, #4b4740);
  font-size: 0.94em;
  margin: 0;
}
.lm-event__venue a,
.lm-event__artists a {
  border-radius: 3px;
  color: var(--lm-widget-link);
  font-weight: 600;
  text-decoration: underline;
  text-decoration-color: var(--lm-widget-link-soft);
  text-decoration-thickness: 1px;
  text-underline-offset: 3px;
  transition: color 140ms ease, text-decoration-color 140ms ease, background-color 140ms ease;
}
.lm-widget__actions {
  margin-top: 14px;
}
.lm-widget--list .lm-widget__actions,
.lm-widget--tiles .lm-widget__actions,
.lm-widget--empty .lm-widget__actions {
  border-top: 1px solid var(--lm-widget-divider, #e7dfd2);
  display: flex;
  justify-content: center;
  padding-top: 14px;
  text-align: center;
}
.lm-widget--tiles .lm-widget__events {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(min(100%, 180px), 1fr));
  gap: 12px;
}
.lm-widget--tiles.lm-widget--columns .lm-widget__events {
  grid-template-columns: repeat(var(--lm-widget-columns, 3), minmax(0, 1fr));
}
.lm-widget--tiles .lm-event {
  background: var(--lm-widget-card-bg, var(--lm-widget-bg, #ffffff));
  border: 1px solid var(--lm-widget-border, #ded4c3);
  border-radius: 10px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04), 0 4px 12px rgba(0, 0, 0, 0.02);
  display: flex;
  flex-direction: column;
  gap: 0;
  min-width: 0;
  overflow: hidden;
  padding: 0;
  transition: transform 180ms ease, box-shadow 180ms ease, border-color 180ms ease;
  width: 100%;
}
.lm-widget--tiles .lm-event:hover {
  border-color: var(--lm-widget-link-soft);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
  transform: translateY(-2px);
}
.lm-widget--tiles .lm-event:hover .lm-event__image {
  transform: scale(1.04);
}
.lm-widget--tiles .lm-event:first-child {
  border-top: 1px solid var(--lm-widget-border, #ded4c3);
  padding-top: 0;
}
.lm-widget--tiles .lm-event--with-image {
  display: flex;
  flex-direction: column;
}
.lm-widget--tiles .lm-event__image-link,
.lm-widget--tiles .lm-event__image {
  aspect-ratio: 1 / 1;
  border-radius: 0;
  display: block;
  height: auto;
  overflow: hidden;
  width: 100%;
}
.lm-widget--tiles .lm-event__image {
  transition: opacity 180ms ease, transform 240ms ease;
}
.lm-widget--tiles .lm-event__body {
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 8px;
  min-width: 0;
  padding: 12px 14px 14px;
}
.lm-widget--tiles .lm-event:not(.lm-event--with-image) .lm-event__body {
  padding: 14px;
}
.lm-widget--tiles .lm-event__title {
  font-size: 0.95em;
  line-height: 1.35;
  min-width: 0;
  overflow-wrap: break-word;
  word-break: break-word;
}
.lm-widget--tiles .lm-event__meta {
  gap: 4px;
  min-width: 0;
}
.lm-widget--tiles .lm-event__meta-row {
  display: flex;
  flex-wrap: wrap;
  gap: 2px 6px;
  min-width: 0;
}
.lm-widget--tiles .lm-event__meta-label {
  font-size: 0.72em;
}
.lm-widget--tiles .lm-event__date {
  font-size: 0.88em;
  line-height: 1.35;
  min-width: 0;
  overflow-wrap: break-word;
  word-break: break-word;
}
.lm-widget--tiles .lm-event__venue,
.lm-widget--tiles .lm-event__artists {
  font-size: 0.88em;
  line-height: 1.35;
  min-width: 0;
  overflow-wrap: break-word;
  word-break: break-word;
}
.lm-widget__more,
.lm-widget__cta {
  border-radius: 999px;
  color: var(--lm-widget-link);
  display: inline-flex;
  font-weight: 700;
  line-height: 1.2;
  text-decoration: underline;
  text-decoration-color: var(--lm-widget-link-soft);
  text-decoration-thickness: 2px;
  text-underline-offset: 4px;
  transition: color 140ms ease, text-decoration-color 140ms ease, background-color 140ms ease;
}
.lm-widget__cta {
  background: var(--lm-widget-link-soft);
  padding: 0.45em 0.7em;
  text-decoration-color: transparent;
}
.lm-event__title:focus-visible,
.lm-event__image-link:focus-visible,
.lm-event__venue a:focus-visible,
.lm-event__artists a:focus-visible,
.lm-widget__more:focus-visible,
.lm-widget__cta:focus-visible {
  background: var(--lm-widget-link-soft);
  box-shadow: 0 0 0 3px var(--lm-widget-focus);
  outline: 0;
}
.lm-widget--loading,
.lm-widget--empty,
.lm-widget--error,
.lm-widget--membership-required,
.lm-widget--calendar-unavailable {
  min-height: 76px;
}
.lm-widget--scrollable {
  height: var(--lm-widget-scroll-height, 360px);
  overflow-y: auto;
  overscroll-behavior: contain;
  scrollbar-gutter: stable;
}
.lm-widget--scrollable:focus-within {
  box-shadow: 0 0 0 3px var(--lm-widget-focus);
}
.lm-widget--error .lm-widget__message {
  color: #7d2f22;
}
.lm-widget--membership-required {
  background: #fff7ed;
  border-color: #d97706;
  border-left: 5px solid #d97706;
}
.lm-widget--membership-required .lm-widget__message {
  color: #7c2d12;
  font-weight: 650;
  padding-left: 1.35em;
  position: relative;
}
.lm-widget--membership-required .lm-widget__actions {
  display: flex;
  justify-content: center;
}
.lm-widget--membership-required .lm-widget__message::before {
  align-items: center;
  background: #d97706;
  border-radius: 999px;
  color: #fff7ed;
  content: "!";
  display: inline-flex;
  font-size: 0.78em;
  font-weight: 800;
  height: 1em;
  justify-content: center;
  left: 0;
  line-height: 1;
  position: absolute;
  top: 0.18em;
  width: 1em;
}
.lm-widget--membership-required .lm-widget__cta {
  background: #7c2d12;
  color: #fff7ed;
  text-decoration-color: transparent;
}
.lm-widget--membership-required .lm-widget__cta:hover,
.lm-widget--membership-required .lm-widget__cta:focus-visible {
  background: #9a3412;
  color: #ffffff;
}
@media (max-width: 600px) {
  .lm-widget--tiles.lm-widget--columns .lm-widget__events {
    grid-template-columns: repeat(auto-fill, minmax(min(100%, 150px), 1fr));
  }
}
@media (max-width: 420px) {
  .lm-widget {
    border-radius: 6px;
    padding: 12px;
  }
  .lm-widget__header {
    margin: -12px -12px 12px;
    padding: 10px 12px;
  }
  .lm-event__meta-row {
    grid-template-columns: 1fr;
    gap: 1px;
  }
  .lm-widget--tiles.lm-widget--columns .lm-widget__events,
  .lm-widget--tiles .lm-widget__events {
    grid-template-columns: 1fr;
  }
}
@media (prefers-reduced-motion: reduce) {
  .lm-event__image {
    transition: none;
  }
  .lm-event__image-link--loading::before,
  .lm-event__image--loading {
    animation: none;
  }
}
@keyframes lm-event-image-loading {
  0% {
    background-position: 100% 50%;
  }
  100% {
    background-position: -100% 50%;
  }
}
`;

const STYLE_ID = "lm-events-widget-styles";

export function injectStyles(documentRef: Document = document): void {
  if (documentRef.getElementById(STYLE_ID)) {
    return;
  }
  const style = documentRef.createElement("style");
  style.id = STYLE_ID;
  style.textContent = WIDGET_STYLES;
  documentRef.head.append(style);
}
